import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const FAQS = [
  { q: "Who can apply for Saksham's programs?", a: "Any micropreneur in India — particularly women-led micro and small enterprises — can reach out. We focus on first-generation entrepreneurs in tier-2, tier-3 cities and rural areas, but we welcome anyone who needs guidance." },
  { q: "Is there any fee for the consulting?", a: "No. Saksham is a non-profit and all our consulting, training and loan navigation support is offered free of cost to micropreneurs." },
  { q: "Do you provide direct funding?", a: "We are not a lender. We help micropreneurs access formal credit through government schemes and partner banks." },
  { q: "How can I volunteer or partner with Saksham?", a: "Drop us a note via the Contact Us page. Whether you're a mentor, designer, finance professional or organisation — we'd love to talk." },
  { q: "Do you work outside India?", a: "Currently, our work is focused on India. Our long-term mission is to scale within India before expanding." },
];

export default function FAQs() {
  return (
    <div data-testid="page-faqs" className="bg-[#FAFAFA] min-h-screen">
      <section className="pt-40 pb-16 border-b border-black/5">
        <div className="container-saksham">
          <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-[10px] uppercase tracking-[0.3em] text-[#09B792] font-semibold mb-6">
            Questions, Answered
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }} className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight font-medium max-w-4xl">
            Frequently Asked <em className="text-[#09B792] not-italic">Questions.</em>
          </motion.h1>
        </div>
      </section>

      <section className="section-y">
        <div className="container-saksham max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-b border-black/10">
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl font-medium py-6 hover:no-underline hover:text-[#09B792]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A4A4A] text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-16 bg-white border border-black/5 p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <h3 className="font-serif text-2xl md:text-3xl font-medium">Still have a question?</h3>
              <p className="text-[#4A4A4A] mt-2 text-sm">We usually reply within 48 hours.</p>
            </div>
            <Link to="/contact" data-testid="faqs-cta" className="inline-flex items-center gap-2 bg-[#0A0A0A] text-[#FBD223] hover:bg-[#FBD223] hover:text-[#0A0A0A] px-6 py-3 text-sm font-medium transition-colors whitespace-nowrap">
              Reach out <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
